import * as React from 'react';
import ChannelList from 'components/channelList';
import ChannelEditPage from 'views/programming/channel/edit';
import VodCollectionList from 'components/vodCollectionList';
import VodCollectionEditPage from 'views/programming/vodCollections/edit';
import {channelPermissions} from 'views/programming/channel/permissions';
import {vodCollectionPermissions} from 'views/programming/vodCollections/permissions';

import {IRouteItem} from 'routes';
import {clipPermissions} from 'views/content/clip/permissions';

const paths = {
  channelListPage: '/channels',
  channelEditDetailsPageAlt: '/channels/:id',
  channelEditDetailsPage: '/channels/:id/details',
  channelEditDistributionPage: '/channels/:id/distribution',
  channelEditSettingsPage: '/channels/:id/settings',
  channelEditArtworkPage: '/channels/:id/artwork',
  vodCollectionListPage: '/vod-collections',
  vodCollectionEditDetailsPageAlt: '/vod-collections/:id',
  vodCollectionEditDetailsPage: '/vod-collections/:id/details',
  vodCollectionEditDistributionPage: '/vod-collections/:id/distribution',
  vodCollectionEditArtworkPage: '/vod-collections/:id/artwork',
  vodCollectionEditProgramPage: '/vod-collections/:id/program',
};

const routes: IRouteItem[] = [
  {
    name: 'Programming',
    icon: 'programming',
    showInSideBar: true,
    requiredPermissions: [...channelPermissions.CHANNEL_VIEW.enabled, ...vodCollectionPermissions.VOD_VIEW.enabled],
    children: [
      {
        name: 'Channels',
        path: paths.channelListPage,
        component: () => <ChannelList showFavoriteSearch={true} />,
        breadcrumb: {items: [{text: 'Channels', route: paths.channelListPage}]},
        requiredPermissions: [...channelPermissions.CHANNEL_VIEW.enabled, ...clipPermissions.CLIP_EDIT.enabled],
      },
      {
        name: 'VOD Collections',
        path: paths.vodCollectionListPage,
        component: VodCollectionList,
        breadcrumb: {items: [{text: 'VOD Collections', route: paths.vodCollectionListPage}]},
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
    ],
  },
  {
    name: 'Channel Edit',
    children: [
      {
        name: 'Channel Edit Detail',
        path: paths.channelEditDetailsPage,
        component: ChannelEditPage,
        breadcrumb: {
          items: [
            {text: 'Channels', route: paths.channelListPage},
            {text: 'Channel Details', route: paths.channelEditDetailsPage},
          ],
        },
        requiredPermissions: channelPermissions.CHANNEL_VIEW.enabled,
      },
      {
        name: 'Channel Edit Detail',
        path: paths.channelEditDetailsPageAlt,
        component: ChannelEditPage,
        breadcrumb: {
          items: [
            {text: 'Channels', route: paths.channelListPage},
            {text: 'Channel Details', route: paths.channelEditDetailsPage},
          ],
        },
        requiredPermissions: channelPermissions.CHANNEL_VIEW.enabled,
      },
      {
        name: 'Channel Edit Distribution',
        path: paths.channelEditDistributionPage,
        component: ChannelEditPage,
        breadcrumb: {
          items: [
            {text: 'Channels', route: paths.channelListPage},
            {text: 'Channel Distribution', route: paths.channelEditDistributionPage},
          ],
        },
        requiredPermissions: channelPermissions.CHANNEL_VIEW.enabled,
      },
      {
        name: 'Channel Edit Settings',
        path: paths.channelEditSettingsPage,
        component: ChannelEditPage,
        breadcrumb: {
          items: [
            {text: 'Channels', route: paths.channelListPage},
            {text: 'Channel Settings', route: paths.channelEditSettingsPage},
          ],
        },
        requiredPermissions: channelPermissions.CHANNEL_VIEW.enabled,
      },
      {
        name: 'Channel Edit Artwork',
        path: paths.channelEditArtworkPage,
        component: ChannelEditPage,
        breadcrumb: {
          items: [
            {text: 'Channels', route: paths.channelListPage},
            {text: 'Channel Artwork', route: paths.channelEditArtworkPage},
          ],
        },
        requiredPermissions: channelPermissions.CHANNEL_VIEW.enabled,
      },
    ],
  },
  {
    name: 'VOD Collection Edit',
    children: [
      {
        name: 'VOD Collection Edit Detail',
        path: paths.vodCollectionEditDetailsPage,
        component: VodCollectionEditPage,
        breadcrumb: {
          items: [
            {text: 'VOD Collections', route: paths.vodCollectionListPage},
            {text: 'VOD Collection Details', route: paths.vodCollectionEditDetailsPage},
          ],
        },
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
      {
        name: 'VOD Collection Edit Detail',
        path: paths.vodCollectionEditDetailsPageAlt,
        component: VodCollectionEditPage,
        breadcrumb: {
          items: [
            {text: 'VOD Collections', route: paths.vodCollectionListPage},
            {text: 'VOD Collection Details', route: paths.vodCollectionEditDetailsPage},
          ],
        },
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
      {
        name: 'VOD Collection Edit Distribution',
        path: paths.vodCollectionEditDistributionPage,
        component: VodCollectionEditPage,
        breadcrumb: {
          items: [
            {text: 'VOD Collections', route: paths.vodCollectionListPage},
            {text: 'VOD Collection Distribution', route: paths.vodCollectionEditDistributionPage},
          ],
        },
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
      {
        name: 'VOD Collection Edit Artwork',
        path: paths.vodCollectionEditArtworkPage,
        component: VodCollectionEditPage,
        breadcrumb: {
          items: [
            {text: 'VOD Collections', route: paths.vodCollectionListPage},
            {text: 'VOD Collection Artwork', route: paths.vodCollectionEditArtworkPage},
          ],
        },
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
      {
        name: 'VOD Collection Edit Program',
        path: paths.vodCollectionEditProgramPage,
        component: VodCollectionEditPage,
        breadcrumb: {
          items: [
            {text: 'VOD Collections', route: paths.vodCollectionListPage},
            {text: 'VOD Collection Program', route: paths.vodCollectionEditProgramPage},
          ],
        },
        requiredPermissions: vodCollectionPermissions.VOD_VIEW.enabled,
      },
    ],
  },
];

export default {
  paths,
  routes,
};
